import { date, showAlert } from '@/lib/helpers';
import { headers, search } from './attributes';

export default {
  data() {
    return {
      options: {},
      headers,
      search,
      merchantId: null,
      filterValue: {},
      filterType: [],
      dialog: false,
      isEdit: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        code: '',
        definition: '',
      },
      defaultItem: {
        id: null,
        code: '',
        definition: '',
      },
      formLoading: false,
      formErrors: {},
    };
  },
  computed: {
    filterData() {
      return [
        { label: 'Kode', field: 'code', type: 'text' },
        { label: 'Definisi', field: 'definition', type: 'text' },
        { label: 'Create Date', field: 'created_at', type: 'date' },
        { label: 'Last Update', field: 'updated_at', type: 'date' },
      ];
    },
    allData() {
      return this.$store.state.cmer.allData;
    },
    totalData() {
      return this.$store.state.cmer.totalData;
    },
    totalPage() {
      return this.$store.state.cmer.totalPage;
    },
    loading() {
      return this.$store.state.cmer.loading;
    },
    dialogTitle() {
      return this.isEdit ? 'Edit CMER' : 'Add CMER';
    },
    formFields() {
      return [
        {
          key: 'code',
          label: 'Kode',
          type: 'text',
          maxLength: 3,
          uppercase: true,
          rules: [
            v => !!v || 'Code is required',
            v => (v && v.length <= 3) || 'Code maksimal 3 karakter.',
            v => /^[A-Z0-9]+$/.test(v) || 'Code hanya boleh berisi huruf kapital dan angka.',
          ],
        },
        {
          key: 'definition',
          label: 'Definisi',
          type: 'textarea',
          rows: 3,
          maxLength: 100,
          rules: [
            v => !!v || 'Definition is required',
            v => (v && v.length <= 100) || 'Definition maksimal 100 karakter.',
          ],
        },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      const { page = 1, itemsPerPage = 10 } = this.options;

      this.$store
        .dispatch('cmer/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
          merchantId: this.merchantId,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },
    openAddDialog() {
      this.isEdit = false;
      this.editedIndex = -1;
      this.editedItem = { ...this.defaultItem };
      this.dialog = true;
    },
    openEditDialog(item) {
      this.isEdit = true;
      this.editedIndex = this.allData.indexOf(item);
      this.editedItem = {
        id: item.id,
        code: item.code,
        definition: item.definition,
      };
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.formErrors = {};
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.isEdit = false;
      });
    },
    async saveItem(formData) {
      this.formLoading = true;
      this.formErrors = {};

      try {
        let response;
        if (this.isEdit) {
          response = await this.$store.dispatch('cmer/updateData', {
            date,
            id: this.editedItem.id,
            code: formData.code,
            definition: formData.definition,
          });
        } else {
          response = await this.$store.dispatch('cmer/createData', {
            date,
            code: formData.code,
            definition: formData.definition,
          });
        }

        if (response?.code === 200) {
          showAlert(
            this.$store,
            this.isEdit ? 'Data berhasil diupdate!' : 'Data berhasil ditambahkan!',
            'mdi-check-circle',
            'green'
          );
          this.closeDialog();
          this.getData();
        } else {
          this.handleFieldErrors(response?.data);
          const errorMessage = this.extractErrorMessage(response, 'Terjadi kesalahan!');
          showAlert(
            this.$store,
            errorMessage,
            'mdi-alert',
            'red'
          );
        }
      } catch (error) {
        showAlert(this.$store, 'Terjadi kesalahan!', 'mdi-alert', 'red');
      } finally {
        this.formLoading = false;
      }
    },
    copyToClipboard(content) {
      const text = typeof content === 'object' ? JSON.stringify(content, null, 2) : content;
      navigator.clipboard.writeText(text);
    },
    handleFieldErrors(responseData) {
      if (!responseData) return;
      
      if (typeof responseData === 'object' && responseData !== null && !Array.isArray(responseData)) {
        this.formErrors = { ...responseData };
      }
    },
    extractErrorMessage(responseData, defaultMessage) {
      if (!responseData) return defaultMessage;
      
      const { data, message_en, message_id } = responseData;
      
      if (typeof data === 'string' && data.trim()) {
        return data;
      }
      
      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        const firstField = Object.keys(data)[0];
        if (firstField && Array.isArray(data[firstField]) && data[firstField].length > 0) {
          return data[firstField][0];
        }
      }
      
      return message_en || message_id || defaultMessage;
    },
    clearSearch() {
      this.search.code = '';
      this.search.definition = '';
      this.search.created_at = '';
      this.search.updated_at = '';
    },
    updateSearch() {
      this.getData();
    },
    showType() {
      this.getData();
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};